module.exports = new __parcel__URL__("shop_machines_bp_fire_storm_tracker_cosmetic.c40c3bf8.png").toString();